import { Maybe } from 'maybeasy';
import * as React from 'react';
import { familyCourseOptions, optionForFamily } from '../CourseField/CourseOptions';
import CoursePicker from '../CourseField/CoursePicker';
import { Program } from '../Stores/ShareStore/Types';

interface Props {
  programs: ReadonlyArray<Program>;
  selectedProgramFamilyId: Maybe<number>;
  onChange: (programFamilyId: number) => void;
}

// DVLP-8060: sharing a course by URL chooses the course the way the invite
// page does (same card, same catalog). The URL points at the course itself,
// not a run, so the catalog has one row per family with every run merged, a
// pick sets the program family, and the card lists the runs instead of
// offering them. The catalog floats so the overlay keeps its size.
const CourseFamilyField: React.FC<Props> = ({ programs, selectedProgramFamilyId, onChange }) => {
  const options = familyCourseOptions(programs);
  const selected = selectedProgramFamilyId.andThen((id) => optionForFamily(options, id));

  return (
    <CoursePicker
      options={options}
      selected={selected}
      runs={{ kind: 'state-runs' }}
      catalog="floating"
      onPick={(option) => onChange(option.family.id)}
    />
  );
};

export default CourseFamilyField;
